// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.95 8.73C1.58 8.32 1.58 7.68 1.95 7.27L4.38 4.6C6.5 2.47 9.85 2.47 11.97 4.6L14.39 7.27C14.76 7.68 14.76 8.32 14.39 8.73L11.97 11.4C9.85 13.53 6.5 13.53 4.38 11.4L1.95 8.73Z',
  'M10.25 8C10.25 9.15 9.32 10.08 8.17 10.08C7.03 10.08 6.1 9.15 6.1 8C6.1 6.85 7.03 5.92 8.17 5.92C9.32 5.92 10.25 6.85 10.25 8Z',
];
